export default __webpack_public_path__ + "static/media/Poppins-ExtraLightItalic.9f57e7d4.ttf";